import { Badge } from "reactstrap";
import { BadgesProps } from "../../Types/CommonElementType";

const Badges: React.FC<BadgesProps> = (props) => {
  const { children = "" } = props;
  return <Badge {...props}>{children}</Badge>;
};

export default Badges;
